import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.REACT_APP_API_URL;

const http = axios.create({
    baseURL: API_URL,
    // headers: {
    //     "Content-type": "application/json",
    // },
    headers: authHeader(),
});

const getAll = () => {
    return http.get("/members");
};

const get = (id) => {
    return http.get(`/members/${id}`);
};

const create = (username, email, password, roles) => {
    return http.post("/members", {
        username,
        email,
        password,
        roles,
    });
};

const update = (id, data) => {
    return http.put(`/members/${id}`, data);
};

const updatePercentages = (data) => {
    return http.put("/members", data);
};

const remove = (id) => {
    return http.delete(`/members/${id}`);
};

const removeAll = () => {
    return http.delete(`/members`);
};

const findByUsername = (username) => {
    return http.get(`/members`, {
        params: {
            username: username,
        },
    });
};

const AdminService = {
    getAll,
    get,
    create,
    update,
    updatePercentages,
    remove,
    removeAll,
    findByUsername,
};

export default AdminService;
